(function () {
  if (window.__underCardSubscribeInit) return;
  window.__underCardSubscribeInit = true;

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('.product-card__under-card-atc');
      if (!btn) return;
      if (btn.dataset.hasSellingPlans !== 'true') return;
      if (localStorage.getItem('subscribe-save-mode') !== 'true') return;
      if (!btn.dataset.productUrl) return;

      event.preventDefault();
      event.stopPropagation();
      window.location.href = btn.dataset.productUrl;
    },
    true
  );
})();
